<script>
import { mapGetters } from 'vuex';
import { useAccount } from 'dashboard/composables/useAccount';
import Banner from 'dashboard/components/ui/Banner.vue';
import { frontendURL } from 'dashboard/helper/URLHelper';

export default {
  components: { Banner },
  setup() {
    const { accountId } = useAccount();
    return { accountId };
  },
  computed: {
    ...mapGetters({
      isOnChatwootCloud: 'globalConfig/isOnChatwootCloud',
      isTrial: 'stripe/isTrial',
      daysRemaining: 'stripe/getDaysRemaining',
    }),
    shouldShowBanner() {
      return this.isOnChatwootCloud && this.isTrial;
    },
    bannerMessage() {
      return this.$t('GENERAL_SETTINGS.TRIAL_DAYS_REMAINING', {
        count: this.daysRemaining,
      });
    },
    // Real cancellation has no backend action yet (POST
    // /subscription/cancel-trial isn't built) — this links to Settings →
    // Billing as an interim landing spot rather than pretending a working
    // cancel flow exists.
    cancelTrialUrl() {
      return frontendURL(`accounts/${this.accountId}/settings/billing`);
    },
  },
  methods: {
    routeToPricingTable() {
      this.$router.push({
        name: 'pricing_table',
        params: { accountId: this.accountId },
      });
    },
  },
};
</script>

<template>
  <Banner
    v-if="shouldShowBanner"
    color-scheme="secondary"
    :banner-message="bannerMessage"
    :href-link="cancelTrialUrl"
    :href-link-text="$t('GENERAL_SETTINGS.CANCEL_TRIAL')"
    has-action-button
    :action-button-label="$t('GENERAL_SETTINGS.VIEW_PLANS')"
    @click="routeToPricingTable"
  />
</template>
